export const defaultState = () => {
    return {
        heartRateInputMethod: null,
        respiratoryRateInputMethod: null,
    };
};

const state = defaultState();
export default state;